import { DateTime } from 'luxon';
import { Observable, Subscription, timer } from 'rxjs';

import { DEFAULT_TIME_FORMAT } from './locales';

export const formatTime = (time: DateTime | number, timeZone?: string): string => {
  const dateTime = DateTime.isDateTime(time) ? (timeZone ? time.setZone(timeZone) : time) : DateTime.fromMillis(time, { zone: timeZone });

  return dateTime.toFormat(DEFAULT_TIME_FORMAT).toUpperCase();
};

export const getRemainingMsecUntil$ = (time: string, interval: 'second' | 'minute' = 'minute'): Observable<number> => {
  return new Observable((observer) => {
    const sub = new Subscription();
    const emitMsecAndScheduleNextMinute = () => {
      const { msec, msecForNextInterval } = getRemainingMsecUntil(time, interval);

      observer.next(msec);

      sub.add(
        timer(msecForNextInterval).subscribe(() => {
          emitMsecAndScheduleNextMinute();
        })
      );
    };

    emitMsecAndScheduleNextMinute();

    return () => {
      sub?.unsubscribe();
    };
  });
};

const getRemainingMsecUntil = (
  time: string,
  interval: 'second' | 'minute' = 'minute'
): {
  msec: number;
  msecForNextInterval: number;
} => {
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  const intervalMsec = interval === 'second' ? 1000 : 60_000;
  const now = DateTime.now();
  const date = DateTime.fromISO(time);
  const msecUntilNextInterval = (date.toMillis() - now.toMillis()) % intervalMsec;

  return {
    msec: date.toMillis() - now.toMillis(),
    msecForNextInterval: msecUntilNextInterval < 0 ? msecUntilNextInterval + intervalMsec : msecUntilNextInterval,
  };
};
export const everyMinute$ = new Observable<DateTime>((observer) => {
  const sub = new Subscription();
  const emitMsecAndScheduleNextMinute = () => {
    const minuteMsec = 60_000;
    const now = DateTime.now();
    const msecForNextMinute = minuteMsec - (now.toMillis() % minuteMsec);

    observer.next(now);

    sub.add(
      timer(msecForNextMinute).subscribe(() => {
        emitMsecAndScheduleNextMinute();
      })
    );
  };

  emitMsecAndScheduleNextMinute();

  return () => {
    sub?.unsubscribe();
  };
});
